export default "../img/logo-powered-by.svg";